import React from 'react';
import { Avatar } from '../Avatar';
import { block } from '../utils/cn';
import './User.css';
const b = block('user');
export const UserQa = {
    NAME: 'user-name',
    DESCRIPTION: 'user-description',
};
export const User = React.forwardRef(({ avatar, name, description, size, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, className, style, qa, }, ref) => {
    const showDescription = Boolean(size !== 'xs' && description);
    return (React.createElement("div", { className: b({ size }, className), "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, style: style, "data-qa": qa, ref: ref },
        avatar ? (React.createElement("div", { className: b('avatar') }, React.isValidElement(avatar) ? avatar : React.createElement(Avatar, Object.assign({}, avatar, { size: size })))) : null,
        name || showDescription ? (React.createElement("div", { className: b('info') },
            name ? (React.createElement("span", { className: b('name'), "data-qa": UserQa.NAME }, name)) : null,
            showDescription ? (React.createElement("span", { className: b('description'), "data-qa": UserQa.DESCRIPTION }, description)) : null)) : null));
});
User.displayName = 'User';
